/**
 * Grouping for a workflow template list row.
 *
 * `surface` is the filter of record on the client. A `thread-action-` slug
 * always groups as `'thread'`, even if the wire field says `'lobby'` (one-way
 * harden against stale lobby copies). `surface: 'thread'` on a non-prefix
 * slug stays `'thread'` (D5 additive metadata). Omitted surface falls back to
 * the prefix, else `'lobby'`. Do not invent a second prefix constant: this is
 * the frontend mirror of `THREAD_ACTION_TEMPLATE_SLUG_PREFIX`.
 */
export const THREAD_ACTION_SLUG_PREFIX = 'thread-action-'

export function templateSurface(summary: {
  surface?: 'lobby' | 'thread'
  slug: string
}): 'lobby' | 'thread' {
  if (summary.slug.startsWith(THREAD_ACTION_SLUG_PREFIX)) {
    return 'thread'
  }

  if (summary.surface === 'thread' || summary.surface === 'lobby') {
    return summary.surface
  }

  return 'lobby'
}
